import React from 'react';
import { Box, Typography } from '@mui/material';
import { AddOn, AddOnChannels, getAddOnDetails } from 'common/modules/plans';
import ContainerBox from 'components/ContainerBox';
import { useTranslation } from 'services/localization';
import * as ViewActions from 'actions/ViewActions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import UpgradeButton from '../UpgradeButton';

export interface AddOnPromoBlockProps {
	addOn: AddOn;
}
const AddOnPromoBlock = (props: AddOnPromoBlockProps) => {
	const { addOn } = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const location = useLocation();
	const addOnDetails = getAddOnDetails(addOn, t);
	return (
		<ContainerBox>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					justifyContent: 'space-between',
					flexWrap: 'wrap',
				}}
			>
				<Box>
					<Typography variant="h6">{addOnDetails.name}</Typography>
					<Typography variant="body1">{addOnDetails.subHeader}</Typography>
				</Box>
				<Box>
					<UpgradeButton
						onClick={() =>
							dispatch(
								ViewActions.openAddOnModal(addOn, AddOnChannels.cta_button, location.pathname),
							)
						}
						text={t('promoPages.blocks.enableBlock', {
							blockName: addOnDetails.name,
							defaultValue: 'Enable {{blockName}}',
						})}
					/>
				</Box>
			</Box>
		</ContainerBox>
	);
};

export default AddOnPromoBlock;
